import delegate from "delegate-it";
import ajax from "@/scripts/common/ajax";
import { scrollToIfNeeded } from "@/scripts/common/scroll-to";
import { updateQueryParams } from "@/scripts/common/util";

const MASONRY_GAP = 20;

const layoutMasonry = () => {
  const grid = document.querySelector("[data-masonry]");
  if (!grid) return;

  const items = [...grid.children];
  if (!items.length) return;

  // Find viewport anchor to preserve scroll position
  let anchor, anchorTop;
  for (const item of items) {
    const rect = item.getBoundingClientRect();
    if (rect.bottom > 0) {
      anchor = item;
      anchorTop = rect.top;
      break;
    }
  }

  // Reset to auto rows for natural height measurement
  grid.style.gridAutoRows = "auto";
  items.forEach((item) => {
    item.style.gridRowEnd = "";
  });

  const heights = items.map((item) => item.offsetHeight);

  grid.style.gridAutoRows = "1px";
  items.forEach((item, i) => {
    item.style.gridRowEnd = `span ${Math.ceil(heights[i] + MASONRY_GAP)}`;
  });

  // Compensate scroll to prevent jump
  if (anchor) {
    const delta = anchor.getBoundingClientRect().top - anchorTop;
    if (Math.abs(delta) > 1) {
      window.scrollBy(0, delta);
    }
  }
};

let resizeTimer;
const handleResize = () => {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(layoutMasonry, 150);
};

const form = document.querySelector(".filter-form");

const updateResults = async () => {
  const pageContent = document.querySelector("[data-page-content]");

  pageContent.classList.add("is-loading");

  const res = await ajax.get(window.location.href).json();

  pageContent.innerHTML = res.page;
  pageContent.classList.remove("is-loading");
  layoutMasonry();

  if (res.isFiltered) {
    scrollToIfNeeded(pageContent, 24);
  }
};

const handleFilter = (e) => {
  const url = updateQueryParams([[e.target.name, e.target.value]]);

  window.history.replaceState({}, "", url);

  updateResults();
};

const handleFilterClear = (e) => {
  e.preventDefault();

  const url = updateQueryParams(false);
  window.history.replaceState({}, "", url);

  updateResults();
};

document.addEventListener("DOMContentLoaded", () => {
  layoutMasonry();
  window.addEventListener("resize", handleResize);
  document.documentElement.addEventListener("paginatedlist:update", layoutMasonry);

  if (form) {
    delegate(".filter-form", "change", handleFilter);
    delegate(".filter-form", "form:clear", handleFilterClear);
  }
});
